/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

export const months: Record< string, string > = {
	january: _x( 'January', 'text', 'nelio-forms' ),
	february: _x( 'February', 'text', 'nelio-forms' ),
	march: _x( 'March', 'text', 'nelio-forms' ),
	april: _x( 'April', 'text', 'nelio-forms' ),
	may: _x( 'May', 'text', 'nelio-forms' ),
	june: _x( 'June', 'text', 'nelio-forms' ),
	july: _x( 'July', 'text', 'nelio-forms' ),
	august: _x( 'August', 'text', 'nelio-forms' ),
	september: _x( 'September', 'text', 'nelio-forms' ),
	october: _x( 'October', 'text', 'nelio-forms' ),
	november: _x( 'November', 'text', 'nelio-forms' ),
	december: _x( 'December', 'text', 'nelio-forms' ),
};
